import React from 'react';
import { motion } from 'framer-motion';
import { QuestionMark, CheckCircle } from './Icons';
export function FAQSection() {
  const faqs = [{
    q: '¿Mi hijo de verdad dejará el iPad por esto?',
    a: 'Sí, porque no usamos la fuerza, usamos la curiosidad. El método baja su umbral de dopamina gradualmente para que jugar con bloques vuelva a ser divertido.'
  }, {
    q: 'No tengo tiempo para manualidades.',
    a: 'Perfecto. Este método es "Zero-Prep". Son actividades que tardas 2 minutos en montar y ellos tardan 40 en terminar.'
  }, {
    q: '¿Es un pago único?',
    a: 'Sí. Sin suscripciones. Acceso de por vida a todas las actualizaciones de 2026.'
  }];
  return <section className="py-10 md:py-20 px-4 bg-white" data-id="element-13">
      <div className="max-w-4xl mx-auto" data-id="element-14">
        <div className="text-center mb-8 md:mb-16" data-id="element-15">
          <div className="inline-flex items-center justify-center p-3 bg-cream rounded-full mb-4" data-id="element-16">
            <QuestionMark className="w-8 h-8 text-navy" data-id="element-17" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-18">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4 md:space-y-6" data-id="element-19">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream-dark rounded-2xl p-6 md:p-8 border border-cream" data-id="element-20">
              <h3 className="text-xl md:text-2xl font-bold text-navy mb-4 flex gap-3 items-start" data-id="element-21">
                <span className="text-terracotta font-serif text-2xl" data-id="element-22">❓</span>
                {faq.q}
              </h3>
              <div className="flex gap-3 items-start pl-2 md:pl-8" data-id="element-23">
                <CheckCircle className="w-6 h-6 text-sage flex-shrink-0 mt-1" data-id="element-24" />
                <p className="text-lg text-warm-dark leading-relaxed" data-id="element-25">
                  {faq.a}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}